import ItemName from "NstyleComponents/dist/components/Text/ItemName";
import PropTypes from "prop-types";
import React from "react";
import {AssignmentSortModel} from "../../../../models/assignments/AssignmentModel";
import {SortArrow} from "../../../common/SortArrow";

export const SortableColumnHeader = ({onSort, columnDisplayName,
                                      columnName, sortOptions, className}) => {

    const sortArrow = () => {
        return sortOptions.columnName === columnName
        ? <SortArrow direction={sortOptions.direction} className="assignments__sort-icon" />
        : null;
    };

    return <div
            className={`assignments__column assignments__column--sortable column ${className}`}
            onClick={() => onSort(columnName)}>
        <ItemName className="assignments__item-name">
            {columnDisplayName} {sortArrow()}
        </ItemName>

    </div>;
};

SortableColumnHeader.propTypes = {
    onSort: PropTypes.func,
    className: PropTypes.string,
    columnDisplayName: PropTypes.string,
    columnName: PropTypes.string,
    sortOptions: PropTypes.shape(AssignmentSortModel)
};
